import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <header className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-39">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-40">
        <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Fine dining atmosphere" className="w-full h-full object-cover" data-id="element-41" />
        <div className="absolute inset-0 bg-neutral-950/70 mix-blend-multiply" data-id="element-42"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-neutral-950/40 via-transparent to-neutral-950" data-id="element-43"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto flex flex-col items-center" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-45">
          <p className="text-amber-500 uppercase tracking-[0.3em] text-sm font-medium mb-6" data-id="element-46">
            A Legacy of Taste
          </p>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-stone-50 mb-8 tracking-tight leading-tight" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-47">
          Cheah Family Foods
        </motion.h1>

        <motion.div className="w-px h-16 bg-amber-500/50 mx-auto mb-8" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 64,
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeInOut'
      }} data-id="element-48" />

        <motion.p className="text-lg md:text-xl text-stone-300 max-w-2xl mx-auto font-light leading-relaxed" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8,
        ease: 'easeOut'
      }} data-id="element-49">
          A family of distinct restaurants serving the heart of Paducah,
          Kentucky with passion, quality, and warm hospitality.
        </motion.p>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center text-stone-400" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.2
    }} data-id="element-50">
        <span className="text-xs uppercase tracking-widest mb-3" data-id="element-51">Discover</span>
        <motion.div className="w-px h-12 bg-stone-400/30 relative overflow-hidden" data-id="element-52">
          <motion.div className="absolute top-0 left-0 w-full h-1/2 bg-stone-400" animate={{
          y: [0, 48, 48]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-53" />
        </motion.div>
      </motion.div>
    </header>;
}